import { put, takeLatest, call } from "redux-saga/effects";
import {
  SCHEDULE_STATUS_PAGE_LOAD,
  scheduleStatusLoaded,
} from "../actions/schedule-status";
import scheduleStatus from "sc/backend/oncall/partners/regions/schedule-status";
import { showErrorPage } from "../../../../actions/ui/location";

const scheduleStatusPageLoadSaga = function*(action) {
  try {
    const result = yield call(scheduleStatus);
    yield put(scheduleStatusLoaded(result.regions));
  } catch (ignore) {
    yield put(showErrorPage());
  }
};

export default function*() {
  //noinspection JSCheckFunctionSignatures
  yield takeLatest(SCHEDULE_STATUS_PAGE_LOAD, scheduleStatusPageLoadSaga);
}



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/sagas/schedule-status-page-load.js